import React from "react";
import { twMerge } from "tailwind-merge";

interface CardProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const Card: React.FC<CardProps> = ({ children, className, style }) => {
  return (
    <div
      className={twMerge(
        "bg-[var(--card-bg-color)] text-[var(--card-text-color)]",
        className
      )}
      style={style}
    >
      {children}
    </div>
  );
};

export default Card;
